import { IController } from 'angular';
import { ICourseDiff } from '../../../../../ng2/shared/typings/interfaces/course-diff.interface';
import { SpinnerModal } from '../../../../shared/modals/status-spinner/status-spinner.service';
import { ISdcStore } from '../../../flux/sdc-store.interface';

export class CreditGapsTransferWizardCtrl implements IController {
  static $inject: string[] = ['$scope', 'SpinnerModal', 'SDCStore'];

  public courseDiffs: ICourseDiff[];
  public uiReady: boolean = false;

  // bindings
  public currentUser;

  constructor(private $scope, private SpinnerModal: SpinnerModal, private SDCStore: ISdcStore) {}

  $onInit(): void {
    this.$scope.$listenTo(this.SDCStore, ['ui', 'isLoading'], () => {
      const isLoading = this.SDCStore.getUiState().isLoading;
      if (!isLoading) {
        this.SpinnerModal.deactivateSpinner();
        this.uiReady = true;
      }
    });
  }
}
